import { render, staticRenderFns } from "./SyllabusBuilder.vue?vue&type=template&id=2a9a4bb9&scoped=true"
import script from "./SyllabusBuilder.vue?vue&type=script&lang=js"
export * from "./SyllabusBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a4bb9",
  null
  
)

export default component.exports